module.exports = __webpack_public_path__ + "static/media/credit-cards.fc99f2c6.png";